import { useTranslation } from 'react-i18next';

/**
 * Returns a translator scoped to the 'errors' namespace.
 * Falls back to UNKNOWN for any unmapped code, including future backend codes
 * not yet added to errors.json.
 *
 * Usage:
 *   const tError = useErrorTranslation();
 *   tError(extractGqlErrorCode(error))  // → user-facing string
 *   tError('title')                     // → "Error"
 */
export function useErrorTranslation(): (code: string) => string {
  const { t } = useTranslation('errors');
  return (code: string): string => t(code, { defaultValue: t('UNKNOWN') });
}
